module.exports = __webpack_public_path__ + "static/img/product.bcbe551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product.png
// module id = 253
// module chunks = 1